import { Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy, Renderer2 } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { SfDataService } from '../../services/sf-data.service';
import { Utilities } from '../../services/utilities';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IDPReport } from '../../models/IDPReport.model';
import { UserEdit } from '../../models/user-edit.model';
import { Role } from '../../models/role.model';
import { Permission } from '../../models/permission.model';
import { Subject } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-emaillogs',
    templateUrl: './emaillogs.component.html',
    styleUrls: ['./emaillogs.component.scss'],
    standalone: false
})
export class EmaillogsComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;
  dtOptions: any = {};
  currentEmailHtml: SafeHtml = '';
  // Toggles the Email Details modal between the default width and a wide/expanded view.
  isEmailModalExpanded = false;

  emailStatuses: string[] = ['New', 'Sent', 'Failed', 'Delivered']; // customize as needed
  createdDateFrom?: string;
  createdDateTo?: string;

  public iDPReports: any = [
    { label: "US", value: "US" },
    { label: "Canada", value: "Canada" }
  ]



  public iDPICD: any = [
    { label: "Active", value: "Active" },
    { label: "Services Ended", value: "Services Ended" },
    { label: "Pending Onboarding", value: "Pending Onboarding" }
  ]



  public iDPOffice: any = [
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" }
  ]
  public userEdit: UserEdit;
  @Input()
  isViewOnly: boolean;

  @Input()
  isGeneralEditor = false;



  constructor(private alertService: AlertService, private renderer: Renderer2, private sfDataService: SfDataService, private accountService: AccountService, private router: Router, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (!this.canViewCustomers) {
      this.router.navigate(['/']);
    }

    
      this.dtOptions = {
        pagingType: 'full_numbers',
        processing: true,
        serverSide: false,
        ajax: (dataTablesParameters: any, callback) => {
          this.sfDataService.getEmails().subscribe(
            (resp) => {
              //console.log(resp);
              callback({ data: resp || [] });
              $('.dt-buttons').addClass('pull-right');
              // Initialize tooltips after data loads
              setTimeout(() => this.initializeEmailBodyPopovers(), 50);
            },
            (error) => {
              console.error('Error loading emails:', error);
              callback({ data: [] });
            }
          );
        },
        columns: [
          { 
            title: 'Subject', 
            data: 'mailSubject',
            width: '40%',
            orderable: true,
            searchable: true,
            render: (data: any, type: any, full: any) => {
              return `<span class="email-subject-tooltip" data-tooltip="${this.escapeHtml(JSON.stringify(full))}" style="cursor: pointer; white-space: normal; word-break: break-word;">${data || 'N/A'}</span>`;
            }
          },
          { 
            title: 'Status', 
            data: 'status',
            width: '12%',
            orderable: true,
            searchable: true
          },

          {
            title: 'Created Date',
            data: 'createdDateTime',
            width: '15%',
            orderable: true,
            searchable: false,
            render: function (data: any) {
              if (data) {
                try {
                  return new Date(data).toLocaleString();
                } catch (e) {
                  return data;
                }
              }
              return '';
            }
          },
          {
            title: 'Action',
            data: 'id',
            width: '15%',
            orderable: false,
            searchable: false,
            render: function (data: any) {
              return `<button class="btn btn-sm btn-primary send-email-btn" data-email-id="${data}" style="white-space: nowrap;">Send Email</button>`;
            }
          }
        ],
        dom: 'lBfrtip',
        order: [],
        responsive: true,
        scrollX: true,
        buttons: [
          { extend: 'excel', title: 'Email Logs', text: 'Export to Excel', className: 'btn btn-sm btn-success mb-2 pull-right' }
        ],
        columnDefs: [
          {
            targets: -1,
            className: 'dt-center'
          }
        ],
        drawCallback: () => {
          this.initializeEmailBodyPopovers();
        }
      };
    
  }


  filterTableByStatus(status: string) {
    const table = $('#tbldata').DataTable();
    if (status == null) {
      table.column(2).search('').draw();
    } else {
      table.column(2).search(status).draw();
    }
    // Reinitialize popovers after filter
    setTimeout(() => this.initializeEmailBodyPopovers(), 100);
  }

  filterByStatus(status: string | null) {
    const table = $('#tbldata').DataTable();
    if (!status) {
      table.column(2).search('').draw();
    } else {
      table.column(2).search(`^${status}$`, true, false).draw();
    }
    // Reinitialize popovers after filter
    setTimeout(() => this.initializeEmailBodyPopovers(), 100);
  }

  clearAllFilters() {
    const table = $('#tbldata').DataTable();
    this.createdDateFrom = null;
    this.createdDateTo = null;
    
    $.fn.dataTable.ext.search = $.fn.dataTable.ext.search.filter(fn => !fn.name.includes('filterByDateRange'));
    (table.columns() as any).every(function () {
      this.search('');
    });
    table.draw();
    // Reinitialize popovers after clearing filters
    setTimeout(() => this.initializeEmailBodyPopovers(), 100);
  }

  filterByDateRange() {
    const table = $('#tbldata').DataTable();

    if (this.createdDateFrom && this.createdDateTo) {
      const from = new Date(this.createdDateFrom);
      const to = new Date(this.createdDateTo);

      $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
        const createdDateStr = data[4];
        if (!createdDateStr) return true;
        
        try {
          const createdDate = new Date(createdDateStr);
          return createdDate >= from && createdDate <= to;
        } catch (e) {
          return true;
        }
      });
    } else {
      $.fn.dataTable.ext.search = $.fn.dataTable.ext.search.filter(fn => !fn.name.includes('filterByDateRange'));
    }

    table.draw();
    // Reinitialize popovers after date range filter
    setTimeout(() => this.initializeEmailBodyPopovers(), 100);
  }


  filterTableByStatusICD(status: string) {
    const table = $('#tbldata').DataTable();
    if (status == null) {
      table.column(2).search('').draw();
    } else {
      table.column(2).search(status).draw();
    }
  }

  filterTableByStatusOffice(status: string) {
    const table = $('#tbldata').DataTable();
    if (status == null) {
      table.column(2).search('').draw();
    } else {
      table.column(2).search(`^${status}$`, true, false).draw();
    }
  }

  //handleViewClick(encryptID: string) {
  //  // Perform the desired action, such as navigating to a new page
  //  //this.router.navigate(['/icddetail/icdinfo', encryptID]);

  //  //console.log(encryptID);
  //  ////console.log(form);
  //}

  //handleDocumentClick(event: MouseEvent) {
  //  const target = event.target as HTMLElement;
  //  if (target.hasAttribute('encyrptID')) {
  //    const encryptID = target.getAttribute('encyrptID');
  //    this.handleViewClick(encryptID);
  //  }
  //}

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      const target = event.target as HTMLElement;
      
      // Close popovers when clicking anywhere except:
      // - The email subject itself
      // - Inside the popover
      // - The close button
      if (!target.classList.contains('email-subject-tooltip') && 
          !target.closest('.popover') &&
          !target.closest('.email-subject-tooltip') &&
          !target.classList.contains('popover-close-btn') &&
          !target.closest('.popover-close-btn')) {
        this.closeAllPopovers();
      }

      if (event.target.classList.contains('send-email-btn')) {
        const emailId = event.target.getAttribute('data-email-id');
        this.resendEmail(emailId);
      }
      else if (event.target.hasAttribute("encyrptid") && event.target.hasAttribute("form") && event.target.hasAttribute("dcode")) {
        let form = event.target.getAttribute("form");
        let dcode = event.target.getAttribute("dcode");
        let eid = event.target.getAttribute("encyrptid");

        if (form == "closeloc") {
          this.router.navigate(["//icddetail/closeloc//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "moveloc") {
          this.router.navigate(["//icddetail/moveloc//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "changeoffcinfo") {
          this.router.navigate(["//icddetail/changeoffinfo//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "campmain") {
          this.router.navigate(["//icddetail/campmain//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "icdoff") {
          this.router.navigate(["//icddetail/closeicd//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "additionalloc") {
          this.router.navigate(["//icddetail/additional//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "reopenicd") {
          this.router.navigate(["//icddetail/reopenicd//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "inactiveform") {
          this.router.navigate(["//icddetail/inactiveoffice//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "hubmaintain") {
          this.router.navigate(["//icddetail/hubmaintain//" + eid + "/" + form + "/" + dcode]);
        }
      }
    });

    // Initialize popovers for email body preview
    this.initializeEmailBodyPopovers();
  }

  escapeHtml(text: string): string {
    const map: { [key: string]: string } = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

  generateEmailTooltipContent(emailData: any): string {
    // Helper function to trim and check if value is empty
    const getValue = (value: any) => {
      if (!value) return '';
      // normalize to string
      let s = String(value).trim();
      if (s === '') return '';

      // Normalize problematic splits: remove newlines that occur between non-space characters
      // e.g. "H\no\nw" or "H\n-\no" => "How" or "H-no"
      s = s.replace(/(\S)[\r\n]+(?=\S)/g, '$1');

      // If value contains newline-separated lines (attachments displayed vertically),
      // detect and collapse them into a single continuous string when appropriate.
      const lines = s.split(/\r\n|\n|\r/).map(l => l.trim()).filter(l => l.length > 0);
      if (lines.length > 1) {
        // compute average length
        const avgLen = lines.reduce((acc, l) => acc + l.length, 0) / lines.length;

        // If the content looks like many single-character lines (attachment name split per-char),
        // collapse into a single string (no separators).
        const mostlyVeryShort = lines.every(l => l.length <= 2) && lines.length > 3;
        if (mostlyVeryShort) {
          s = lines.join('');
          return s;
        }

        // If avg length is small (e.g., pieces of a filename split across lines), join without breaking words
        if (avgLen <= 3 && lines.length > 3) {
          s = lines.join('');
          return s;
        }

        // Otherwise keep line breaks for readability
        return lines.join('<br/>');
      }

      return s;
    };

    // Helper function to render field only if it has content
    const renderField = (label: string, value: any) => {
      const val = getValue(value);
      if (!val) return '';

      // If val looks like a URL or filename, render as clickable link(s)
      const urls = [] as string[];
      // Split by <br/> if getValue returned multiple lines
      const parts = String(val).split('<br/>');
      parts.forEach(p => {
        const trimmed = p.trim();
        if (/^https?:\/\//i.test(trimmed) || /\.(pdf|docx?|xlsx?|jpg|jpeg|png|txt|csv)$/i.test(trimmed)) {
          urls.push(`<a href="${trimmed}" target="_blank" style="display:inline-block; word-break: normal; white-space: nowrap;">${trimmed}</a>`);
        } else {
          urls.push(trimmed);
        }
      });

      // Use flex layout: keep label and value on the same horizontal row and
      // avoid per-character wrapping by making the value container handle wrapping normally.
      return `<div style="display:flex; gap:8px; align-items:flex-start; margin-bottom:6px; padding:4px 0; border-bottom:1px solid #f0f0f0;"><strong style=\"flex:0 0 220px; min-width:120px;\">${label}:</strong><div style=\"flex:1; color:#555; word-break:normal; white-space:normal;\">${urls.join('<br/>')}</div></div>`;
    };

    // Build email body with only non-empty fields
    const toField = renderField('To', emailData.mailTo);
    const ccField = renderField('CC', emailData.mailCC);
    const bccField = renderField('BCC', emailData.mailBCC);
    const fromField = renderField('From', emailData.emailFrom);
    const statusField = renderField('Status', emailData.status);
    const createdField = emailData.createdDateTime ? `<div style="margin-bottom: 6px; padding: 4px 0; border-bottom: 1px solid #f0f0f0;"><strong>Created Date:</strong> <span style="color: #555;">${new Date(emailData.createdDateTime).toLocaleString()}</span></div>` : '';
    const deliveredField = emailData.deliveredDateTime ? `<div style="margin-bottom: 6px; padding: 4px 0; border-bottom: 1px solid #f0f0f0;"><strong>Delivered Date:</strong> <span style="color: #555;">${new Date(emailData.deliveredDateTime).toLocaleString()}</span></div>` : '';

    const rawBody = emailData.mailBody || '';
    const bodyContent = getValue(rawBody);

    // If mail body already contains HTML tags, render it mostly as-is but force safe CSS
    // to avoid per-character wrapping. Otherwise render the cleaned/plain text.
    let bodyHtml = '';
    if (rawBody && /<[^>]+>/i.test(rawBody)) {
      // Clean up HTML fragments: remove head/meta/title/html/body wrappers and leading excessive <br>
      let cleaned = rawBody.replace(/<meta[\s\S]*?>/gi, '');
      cleaned = cleaned.replace(/<title[\s\S]*?>[\s\S]*?<\/title>/gi, '');
      cleaned = cleaned.replace(/<head[\s\S]*?>[\s\S]*?<\/head>/gi, '');
      cleaned = cleaned.replace(/<\/?(?:html|body)[\s\S]*?>/gi, '');
      // remove DOCTYPE
      cleaned = cleaned.replace(/<!doctype[\s\S]*?>/gi, '');
      // collapse multiple consecutive <br> to a single <br>
      cleaned = cleaned.replace(/(?:<br\s*\/?>\s*){2,}/gi, '<br/>');
      // remove <br/> inserted between single characters (e.g. "H<br/>o<br/>w")
      cleaned = cleaned.replace(/([A-Za-z0-9])(?:\s*(?:<br\s*\/?>|\r?\n))+([A-Za-z0-9])/gi, '$1$2');
      // remove leading <br/>
      cleaned = cleaned.replace(/^(\s|(?:<br\s*\/?>))+/, '');

      // Render the email body as-is (the stored template already lays out well); only guard
      // against per-character text/anchor wrapping. Do NOT force table/column widths — that
      // squeezes the attachment cells and breaks the native layout.
      bodyHtml = `
        <style>
          .email-body-content { white-space: normal !important; word-break: normal !important; overflow-wrap: normal !important; }
          .email-body-content a { display: inline-block !important; white-space: nowrap !important; word-break: normal !important; overflow-wrap: normal !important; }
        </style>
        <div class="email-body-content">${cleaned}</div>`;
    } else {
      bodyHtml = bodyContent;
    }

    const emailBodySection = bodyHtml ? `
      <div style="margin-top: 12px; margin-bottom: 8px; padding-top: 12px; padding-bottom: 8px; border-top: 2px solid #007bff; border-bottom: 2px solid #f0f0f0;">
        <div style="font-weight: bold; color: #007bff; margin-bottom: 8px; font-size: 13px;">EMAIL BODY</div>
        <div style="max-height: 55vh; overflow-y: auto; overflow-wrap: normal; white-space: normal; font-size: 12px; color: #333; padding: 10px; background-color: #f9f9f9; border-radius: 4px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.5; word-break: normal;">
          ${bodyHtml}
        </div>
      </div>
    ` : '';

    // Inline styles included so popover content behaves correctly even if global CSS hasn't been rebuilt/cached
    const inlineStyles = `
      <style>
        .email-tooltip-content { white-space: normal !important; word-break: normal !important; overflow-wrap: anywhere !important; }
        .email-tooltip-content a { display: inline-block !important; white-space: nowrap !important; word-break: normal !important; overflow-wrap: normal !important; }
        .email-tooltip-content .email-body { white-space: pre-wrap !important; }
      </style>`;

    return `
      ${inlineStyles}
      <div class="email-tooltip-content">
        <div style="position: relative; font-size: 12px; line-height: 1.6; width: 100%; max-width: 100%;">
          <div style="background-color: #f8f9fa; padding: 12px; border-radius: 4px; margin-bottom: 12px;">
            <div style="font-size: 13px; font-weight: 600; color: #212529; margin-bottom: 8px; word-break: break-word;">${getValue(emailData.mailSubject) || 'N/A'}</div>
          </div>
          ${toField}
          ${ccField}
          ${bccField}
          ${fromField}
          ${statusField}
          ${createdField}
          ${deliveredField}
          ${emailBodySection}
        </div>
      </div>
    `;
  }

  private initializeEmailBodyPopovers(): void {
    // Replace popover tooltips with a modal-based viewer to avoid layout/timing issues.
    const subjectElements = document.querySelectorAll('.email-subject-tooltip');
    subjectElements.forEach((element: any) => {
      try {
        const tooltipData = JSON.parse(element.getAttribute('data-tooltip'));
        // attach click handler to open modal with sanitized HTML
        element.removeEventListener('click', element._emaillogsClickHandler);
        const handler = (e: any) => {
          e.preventDefault();
          e.stopPropagation();
          this.showEmailDetails(tooltipData);
        };
        // store handler reference so it can be removed later if needed
        (element as any)._emaillogsClickHandler = handler;
        element.addEventListener('click', handler);
      } catch (e) {
        console.error('Error initializing subject click handler:', e);
      }
    });
  }

  toggleEmailModalSize() {
    this.isEmailModalExpanded = !this.isEmailModalExpanded;
  }

  showEmailDetails(emailData: any) {
    try {
      const html = this.generateEmailTooltipContent(emailData);
      this.currentEmailHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      // Always open at the default width; the user can expand from the header.
      this.isEmailModalExpanded = false;
      // show bootstrap modal (try Bootstrap 5 native API, fallback to jQuery, fallback to manual show)
      try {
        const modalEl = document.getElementById('emailDetailsModal');
        if ((window as any).bootstrap && (window as any).bootstrap.Modal) {
          const bsModal = new (window as any).bootstrap.Modal(modalEl);
          bsModal.show();
        } else {
          try { ($('#emailDetailsModal') as any).modal('show'); } catch (e) {
            if (modalEl) {
              modalEl.classList.add('show');
              (modalEl as HTMLElement).style.display = 'block';
            }
          }
        }
      } catch (e) { }
    } catch (e) {
      console.error('Error showing email details', e);
    }
  }

  private closeAllPopovers(): void {
    const subjectElements = document.querySelectorAll('.email-subject-tooltip');
    subjectElements.forEach((element: any) => {
      try {
        ($(element) as any).popover('hide');
      } catch (e) {}
    });
  }

  resendEmail(emailId: string): void {
    this.alertService.startLoadingMessage();
    this.sfDataService.resendEmailLog(emailId).subscribe(
      (response: any) => {
        this.alertService.stopLoadingMessage();
        if (response && response.isSuccess) {
          this.alertService.showMessage('Success', 'Email sent successfully', MessageSeverity.success);
          // Refresh the table
          const table = $('#tbldata').DataTable();
          table.ajax.reload(() => {
            // Reinitialize popovers after table reload
            this.initializeEmailBodyPopovers();
          });
        } else {
          this.alertService.showMessage('Error', response?.description || 'Failed to send email', MessageSeverity.error);
        }
      },
      (error: any) => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage('Error', `Failed to send email: "${Utilities.getHttpResponseMessages(error)}"`, MessageSeverity.error, error);
      }
    );
  }
  //ngAfterViewInit(): void {
  //  this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //    dtInstance.columns().every(function () {
  //      const that = this;
  //      $('input', this.footer()).on('keyup change', function () {
  //        if (that.search() !== this['value']) {
  //          that
  //            .search(this['value'])
  //            .draw();
  //        }
  //      });
  //    });
  //  });

  //}
  //ngOnDestroy(): void {
  //  this.dtTrigger.unsubscribe();
  //}

  //ngAfterViewInit(): void {
  //  $('.dt-buttons').addClass('pull-right');
  //}

  //rerender(): void {
  //  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //    // Destroy the table first
  //    dtInstance.destroy();
  //    // Call the dtTrigger to rerender again
  //    this.dtTrigger.next(true);
  //  });
  //}

  private loadCurrentUserData() {
    this.alertService.startLoadingMessage();

    this.sfDataService.getIDPReports().subscribe(user => this.onCurrentUserDataLoadSuccessful(user)), error => this.onCurrentUserDataLoadFailed(error);

  }

  private onCurrentUserDataLoadSuccessful(iDPReports: IDPReport[]) {
    this.alertService.stopLoadingMessage();
    ////console.log(iDPReports);

    this.iDPReports = iDPReports;
    // initiate our data table
    //this.dtTrigger.next(this.dtOptions);

  }

  private onCurrentUserDataLoadFailed(error: any) {
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage('Load Error', `Unable to retrieve  data from the server.\r\nErrors: "${Utilities.getHttpResponseMessages(error)}"`,
      MessageSeverity.error, error);
    //console.log(error);
    this.iDPReports = [];
  }



  get canViewCustomers() {
    return true;// this.accountService.userHasPermission(Permission.viewUsersPermission); // eg. viewCustomersPermission
  }



}
